import { IBar, INote, ISignature } from "../types";

const syll = {
    t0: "ta",
    t0_5: "fa",
    t1: "te",
    t1_5: "fe",
    t2: "ti",
    t2_5: "fi",
    b0: "ta",
    b1: "fa",
    b2: "te",
    b3: "fe",
};

export const getFrenchBar = (notes: INote[], signature: ISignature) => {
    const syllables: string[] = [];
    let time = 0;
    const { den, num } = signature;
    const isCompound = num === 6 || num === 9;
    notes.forEach(note => {
        if (note.r) {
            syllables.push("");
        } else {
            if (isCompound || note.t) {
                const beat = (4 / den) * 3 * 3;
                switch (time % beat) {
                    case 0:
                        if (note.l === 2 && !note.d) {
                            syllables.push("taa");
                        } else if (note.l === 2 && note.d) {
                            syllables.push("taaa");
                        } else if (note.l === 1) {
                            syllables.push("taaaa");
                        } else {
                            syllables.push("ta");
                        }
                        break;
                    case beat / 6:
                    case 0.5:
                        syllables.push(syll.t0_5);
                        break;
                    case beat / 3:
                    case 1:
                        syllables.push(syll.t1);
                        break;
                    case beat / 2:
                    case 1.5:
                        syllables.push(syll.t1_5);
                        break;
                    case (beat / 3) * 2:
                    case 2:
                        syllables.push(syll.t2);
                        break;
                    case (beat / 6) * 5:
                    case 2.5:
                        syllables.push(syll.t2_5);
                        break;
                    default:
                        syllables.push("?");
                        break;
                }
            } else {
                switch (time % ((4 / den) * 3)) {
                    case 0:
                        if (note.l === 2 && !note.d) {
                            syllables.push("taa");
                        } else if (note.l === 2 && note.d) {
                            syllables.push("taaa");
                        } else if (note.l === 1) {
                            syllables.push("taaaa");
                        } else {
                            syllables.push("ta");
                        }
                        break;
                    case (4 / den / 4) * 3:
                        syllables.push(syll.b1);
                        break;
                    case (4 / den / 2) * 3:
                        syllables.push(syll.b2);
                        break;
                    case (4 / den / 4) * 3 * 3:
                        syllables.push(syll.b3);
                        break;
                    default:
                        syllables.push("?");
                        break;
                }
            }
        }
        time += (4 / note.l) * (note.d ? 1.5 : 1) * (note.t ? 2 : 3);
    });
    return syllables;
};

const getSignatureIndex = (signatures: ISignature[], currentBarIndex: number) => {
    return signatures.findIndex(signature => signature.bar === currentBarIndex);
};

export const getFrenchScore = (bars: (IBar | null)[], signatures: ISignature[]) => {
    let takadimis: string[] = [];
    let signature: ISignature;
    bars.forEach((bar, barIndex) => {
        if (!bar) return;
        const signatureIndex = getSignatureIndex(signatures, barIndex);
        if (signatureIndex !== -1) {
            signature = signatures[signatureIndex];
        }
        takadimis.push(...getFrenchBar(bar.notes, signature));
    });
    return takadimis;
};

export const getFrenchTypes = (bars: (IBar | null)[], signatures: ISignature[]) => {
    const takadimis = getFrenchScore(bars, signatures);
    const uniqueTakadimis = new Set<string>();
    takadimis.forEach(takadimi => {
        uniqueTakadimis.add(takadimi);
    });
    return [...uniqueTakadimis];
};
